import { BaseApplicant } from 'screens/Mutations/utils/types';

const findApplicantLength = (applicants: BaseApplicant[]): number => {
  return applicants.flatMap((app) => app.income.incomes).length;
};
export default findApplicantLength;
